import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56ce9d7d")

_pushScopeId("data-v-56ce9d7d")
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "filert-container" }
const _hoisted_3 = {
  class: "filert-container",
  style: {"margin-top":"20px"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = {
  class: "filert-container",
  style: {"margin-top":"20px"}
}
const _hoisted_8 = { class: "text item" }
const _hoisted_9 = { style: {"color":"red"} }
const _hoisted_10 = { style: {"color":"red"} }
const _hoisted_11 = { class: "text item" }
const _hoisted_12 = { style: {"color":"red"} }
const _hoisted_13 = { style: {"color":"red"} }
const _hoisted_14 = { class: "text item" }
const _hoisted_15 = { style: {"color":"red"} }
const _hoisted_16 = { style: {"color":"red"} }
const _hoisted_17 = { class: "text item" }
const _hoisted_18 = { style: {"color":"red"} }
const _hoisted_19 = { style: {"color":"red"} }
const _hoisted_20 = { m: "t-0 b-2" }
const _hoisted_21 = { m: "t-0 b-2" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 换绑 ")
const _hoisted_28 = { class: "dialog-footer" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 0s ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 1min ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 5min ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 10min ")
const _hoisted_33 = { style: {"color":"#1890ff","cursor":"pointer","display":"inline-block"} }
const _hoisted_34 = { href: "https://gwsd-docs.oss-cn-shenzhen.aliyuncs.com/platform-doc/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E8%B4%A6%E5%8F%B7%E6%A8%A1%E6%9D%BF.xls" }
const _hoisted_35 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#icon-yunxiazai_o-copy" })
], -1)
const _hoisted_36 = { class: "dialog-footer" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 0s ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 1min ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 5min ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 10min ")
const _hoisted_41 = { style: {"color":"#1890ff","cursor":"pointer","display":"inline-block"} }
const _hoisted_42 = { href: "https://custom1.oss-cn-shenzhen.aliyuncs.com/templates/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5ICCID%E6%A8%A1%E6%9D%BF.xls" }
const _hoisted_43 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#icon-yunxiazai_o-copy" })
], -1)
const _hoisted_44 = { class: "dialog-footer" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_53 = { class: "dialog-footer" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_55 = { class: "dialog-footer" }
const _hoisted_56 = { class: "dialog-footer" }
const _hoisted_57 = { class: "bind-imei-value" }
const _hoisted_58 = { class: "bind-imei-value bind-imei-mono" }
const _hoisted_59 = { class: "bind-imei-value bind-imei-mono" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "bind-imei-sec-divider-block" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "bind-imei-sec-divider-line",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createVNode("p", { class: "bind-imei-sec-divider-hint" }, " 用于双卡双IMEI设备，须与主IMEI前9位一致 ")
], -1)
const _hoisted_61 = { class: "bind-imei-sec-input-row" }
const _hoisted_62 = /*#__PURE__*/_createVNode("span", {
  class: "bind-imei-sec-close-icon",
  "aria-hidden": "true"
}, "×", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "bind-imei-add-sec-plus" }, "+", -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode("点击添加副IMEI ")
const _hoisted_65 = { class: "bind-imei-hint-stack" }
const _hoisted_66 = { class: "bind-imei-hint-box" }
const _hoisted_67 = { class: "bind-imei-hint-num" }
const _hoisted_68 = { class: "bind-imei-hint-user-complete-line" }
const _hoisted_69 = { class: "bind-imei-hint-inline-label" }
const _hoisted_70 = { class: "bind-imei-hint-num" }
const _hoisted_71 = {
  key: 1,
  class: "bind-imei-hint-num"
}
const _hoisted_72 = { class: "bind-imei-hint-admin-total" }
const _hoisted_73 = { class: "bind-imei-hint-inline-label" }
const _hoisted_74 = { class: "bind-imei-hint-num" }
const _hoisted_75 = {
  key: 1,
  class: "bind-imei-hint-num"
}
const _hoisted_76 = { class: "bind-imei-hint-num" }
const _hoisted_77 = { class: "bind-imei-hint-box" }
const _hoisted_78 = { class: "dialog-footer" }
const _hoisted_79 = { class: "wb-140" }
const _hoisted_80 = { class: "wb-140 mg-10" }
const _hoisted_81 = { class: "zhpy" }
const _hoisted_82 = { class: "zhpy" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" 0s ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" 1min ")
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" 5min ")
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" 10min ")
const _hoisted_87 = { class: "dialog-footer" }
const _hoisted_88 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_item = _resolveComponent("el-item")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_transfer = _resolveComponent("el-transfer")
  const _directive_waves = _resolveDirective("waves")
  const _directive_permission = _resolveDirective("permission")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.keyValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyValue.value = $event))
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accountList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.keyValue.label,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.keyValue.label = $event)),
        style: {"width":"300px"},
        class: "filter-item"
      }, null, 8, ["modelValue"]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toSearch())),
        icon: "el-icon-search"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        style: {"margin-left":"10px"},
        type: "primary",
        icon: "el-icon-refresh-left",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toReload()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_button, {
        loading: _ctx.downloadLoading,
        class: "filter-item",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleDownload())),
        icon: "el-icon-download"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.export")), 1)
        ]),
        _: 1
      }, 8, ["loading"]), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        loading: _ctx.downallloadLoading,
        class: "filter-item",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleallDownload())),
        icon: "el-icon-download"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.exportall")), 1)
        ]),
        _: 1
      }, 8, ["loading"]), [
        [_directive_waves]
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-plus",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toRouterUserAdd()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        style: {"margin-left":"10px"},
        icon: "el-icon-video-play",
        size: "small",
        type: "success",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleActions('activation')))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.activation")), 1)
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-video-pause ",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleActions('suspend')))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.suspend")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-upload",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toUpload()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.upload")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-upload",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toICCIDUpload()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("route.ICCIDADD")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-upload",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toUploadICCID()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.uploadICCID")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-lock",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.bindingIMEI()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.bindingIMEI")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-goods",
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.batchRenewal()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.BatchRenewal")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        size: "small",
        type: "success",
        icon: "el-icon-goods",
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.cuurencygrantvip()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("route.VIP batch renewal")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      (_ctx.permessionList.includes(201))
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "filter-item",
            size: "small",
            type: "success",
            icon: "el-icon-plus",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addselectGroup()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("route.batch add groups")), 1)
            ]),
            _: 1
          }, 512)), [
            [_directive_waves]
          ])
        : _createCommentVNode("", true),
      (_ctx.permessionList.includes(201))
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            class: "filter-item",
            size: "small",
            type: "success",
            icon: "el-icon-edit",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.editGroup()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.editgroup")), 1)
            ]),
            _: 1
          }, 512)), [
            [_directive_waves]
          ])
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.permessionList.includes(201))
        ? (_openBlock(), _createBlock("span", _hoisted_5, [
            (!_ctx.multi)
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "filter-item",
                  size: "small",
                  type: "success",
                  icon: "el-icon-edit",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.batchEditUserInfo()))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.BatchEdit")), 1)
                  ]),
                  _: 1
                }, 512)), [
                  [_directive_waves]
                ])
              : (_openBlock(), _createBlock(_component_el_item, {
                  key: 1,
                  style: {}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.handleBatchEditUserInfo
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, { onClick: _ctx.cancelmutil }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
          ]))
        : _createCommentVNode("", true),
      _hoisted_6,
      (_ctx.permessionList.includes(202))
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            class: "filter-item",
            size: "small",
            type: "success",
            icon: "el-icon-delete",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.batchDeleteUserInfo()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("route.Batch delete")), 1)
            ]),
            _: 1
          }, 512)), [
            [_directive_waves]
          ])
        : _createCommentVNode("", true),
      (_ctx.permessionList.includes(201))
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 4,
            class: "filter-item",
            size: "small",
            type: "success",
            icon: "el-icon-delete",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.batchSetGPS()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("route.Barch GPS")), 1)
            ]),
            _: 1
          }, 512)), [
            [_directive_waves]
          ])
        : _createCommentVNode("", true),
      (_ctx.permessionList.includes(201))
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 5,
            class: "filter-item",
            size: "small",
            type: "success",
            icon: "el-icon-delete",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.batchAddFunc()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("route.Batch FuncGroup")), 1)
            ]),
            _: 1
          }, 512)), [
            [_directive_waves]
          ])
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_permission, ['二级管理']]
    ]),
    _withDirectives(_createVNode("div", _hoisted_7, [
      (!_ctx.multiImei)
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            clsss: "filter-item",
            size: "small",
            icon: "el-icon-edit",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.batchEditUserIMEI()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("route.Batch update IMEI")), 1)
            ]),
            _: 1
          }, 512)), [
            [_directive_waves]
          ])
        : (_openBlock(), _createBlock(_component_el_item, {
            key: 1,
            style: {}
          }, {
            default: _withId(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleBatchEditUserIMEI
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.cancelmutilIemi()))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ], 512), [
      [_directive_permission, ['总管理']]
    ]),
    _createVNode(_component_el_card, {
      class: "box-card",
      style: {"margin":"10px 0","font-size":"small"}
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t("statistics.threeyearsvirtualcurrency")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t("statistics.available")) + ":" + _toDisplayString(_ctx.virtualTotal) + ", " + _toDisplayString(_ctx.t("statistics.used")) + ":" + _toDisplayString(_ctx.threeusedCount) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.threetotalCount) + "               ", 1),
          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.t("statistics.PromotionalAccountRenewalCoin")) + ":", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + ":" + _toDisplayString(_ctx.PreferensurplusCount) + ", " + _toDisplayString(_ctx.t("statistics.used")) + ":" + _toDisplayString(_ctx.PreferenusedCount) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.PreferentotalCount), 1)
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t("statistics.Industrycurrency")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t("statistics.available")) + ":" + _toDisplayString(_ctx.tradeTotal) + ", " + _toDisplayString(_ctx.t("statistics.used")) + ":" + _toDisplayString(_ctx.tradeusedCount) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.tradetotalCount) + "               ", 1),
          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t("statistics.Oneyearvirtualcurrency")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t("statistics.available")) + ":" + _toDisplayString(_ctx.virtualOneTotal) + ", " + _toDisplayString(_ctx.t("statistics.used")) + ":" + _toDisplayString(_ctx.virtualOneTotalUsed) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.virtualOneTotalCount), 1)
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t("statistics.Oneyearrenewalcurrency")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t("statistics.available")) + ":" + _toDisplayString(_ctx.virtualOneRenewTotal) + ", " + _toDisplayString(_ctx.t("statistics.used")) + ":" + _toDisplayString(_ctx.virtualOneusedCount) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.virtualOnetotalCount) + "               ", 1),
          _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t("statistics.Threeyearrenewalcurrency")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t("statistics.available")) + ":" + _toDisplayString(_ctx.virtualRenewTotal) + ", " + _toDisplayString(_ctx.t("statistics.used")) + ":" + _toDisplayString(_ctx.virtualRenewusedCount) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.virtualRenewtotalCount), 1)
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t("statistics.VIPrenewalcurrency")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t("statistics.available")) + ":" + _toDisplayString(_ctx.vipTotal) + ", " + _toDisplayString(_ctx.t("statistics.used")) + ":" + _toDisplayString(_ctx.vipusedCount) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.viptotalCount) + "               ", 1),
          _createVNode("span", _hoisted_19, _toDisplayString(_ctx.t("dashboard.totalusers")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.t("dashboard.online")) + ":" + _toDisplayString(_ctx.onlineCount) + ", " + _toDisplayString(_ctx.t("dashboard.offline")) + ":" + _toDisplayString(_ctx.onlinefalse) + ", " + _toDisplayString(_ctx.t("statistics.total")) + ":" + _toDisplayString(_ctx.registerCount), 1)
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_el_table, {
      key: _ctx.tableKey,
      data: _ctx.list,
      border: "",
      fit: "",
      "highlight-current-row": "",
      class: "tableheaderColor",
      "row-class-name": _ctx.rowColor,
      "header-row-class-name": _ctx.headerColor,
      style: {"width":"100%"},
      onSelectionChange: _ctx.handleSelectionChange,
      ref: "multipleTableRef"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          type: "expand",
          width: "30px"
        }, {
          default: _withId(({row}) => [
            _createVNode("p", _hoisted_20, _toDisplayString(_ctx.t("table.Online (offline) time")) + ": " + _toDisplayString(row.lastStatusDate || _ctx.t("form.Null")), 1),
            _createVNode("p", _hoisted_21, _toDisplayString(_ctx.t("search.remark")) + ": " + _toDisplayString(row.remarks || _ctx.t("form.Null")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          type: "selection",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.uId'),
          sortable: "",
          prop: "uid"
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.uid), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.accountnumber'),
          sortable: "",
          prop: "account",
          "min-width": "100px",
          width: "auto"
        }, {
          default: _withId(({row}) => [
            (row.show && _ctx.canEditAccount(row))
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: row.account,
                  "onUpdate:modelValue": ($event: any) => (row.account = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (row.show)
                ? (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(row.account), 1))
                : (_openBlock(), _createBlock("div", {
                    key: 2,
                    class: { istypeone: row.type == 1, istypefuone: row.type == -1 }
                  }, [
                    (_ctx.permessionList.includes(201) && _ctx.canEditAccount(row))
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          style: {"color":"#33a6dc"},
                          onClick: ($event: any) => (_ctx.handleEdit(row))
                        }, _toDisplayString(row.account), 9, ["onClick"]))
                      : (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(row.account), 1))
                  ], 2))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.name'),
          sortable: "",
          prop: "name"
        }, {
          default: _withId(({row}) => [
            (row.show)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: row.name,
                  "onUpdate:modelValue": ($event: any) => (row.name = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(row.name), 1))
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.canViewPassword)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: _ctx.t('table.password'),
              sortable: "",
              prop: "password"
            }, {
              default: _withId(({row}) => [
                (row.show)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.password,
                      "onUpdate:modelValue": ($event: any) => (row.password = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(row.password), 1))
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.systempremmsion !== '二级管理')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: _ctx.t('table.createBy'),
              sortable: "",
              prop: "createBy"
            }, {
              default: _withId(({row}) => [
                _createTextVNode(_toDisplayString(row.createBy), 1)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "IMEI",
          width: "auto",
          sortable: "",
          prop: "imei"
        }, {
          default: _withId(({row}) => [
            (row.showImei)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: row.imei,
                  "onUpdate:modelValue": ($event: any) => (row.imei = $event),
                  onBlur: ($event: any) => (_ctx.updateIMEI(row))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  onDblclick: ($event: any) => (_ctx.openDetails(row))
                }, [
                  _createVNode("span", {
                    class: _ctx.tableDataRow()
                  }, _toDisplayString(row.imei ? row.imei : _ctx.t("form.null")), 3)
                ], 40, ["onDblclick"]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.defaultgroup')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.defaultGroupName), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.status'),
          sortable: "",
          prop: "usrValid"
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.usrValid === 1 ? _ctx.t("table.suspend") : _ctx.t("table.activation")), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.AccountType')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.oldType === 6
              ? _ctx.t("form.Preferential")
              : row.type == "5"
              ? _ctx.t("form.VIP")
              : row.oldType === 0
              ? _ctx.t("form.ThreeYears")
              : _ctx.t("form.OneYear")), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('route.function'),
          sortable: "",
          prop: "funcsList"
        }, {
          default: _withId(({row}) => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.funcsList, (item) => {
              return (_openBlock(), _createBlock("div", { key: item }, _toDisplayString(item == 1
                ? _ctx.t("form.Basic package")
                : item == 2
                ? _ctx.t("form.Schedule packages")
                : item == 3
                ? _ctx.t("form.Video packages")
                : ""), 1))
            }), 128))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.createTime'),
          sortable: "",
          prop: "createDate"
        }, {
          default: _withId(({row}) => [
            _createVNode("span", {
              class: _ctx.tableDataRow()
            }, _toDisplayString(row.createDate), 3)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.validDate'),
          prop: "validDate",
          sortable: ""
        }, {
          default: _withId(({row}) => [
            _createVNode("span", {
              class: _ctx.tableDataRow()
            }, _toDisplayString(row.validDate), 3)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.online'),
          sortable: "",
          prop: "onLine"
        }, {
          default: _withId(({row}) => [
            _createVNode("span", {
              class: row.onLine == 2 ? 'online' : 'notonline'
            }, _toDisplayString(row.onLine === 2 ? _ctx.t("dashboard.online") : _ctx.t("dashboard.offline")), 3)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.Remark'),
          "show-overflow-tooltip": true
        }, {
          default: _withId(({row}) => [
            (row.show)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: row.remarks,
                  "onUpdate:modelValue": ($event: any) => (row.remarks = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(row.remarks), 1))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.actions'),
          width: "350",
          "class-name": "buttonSize"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: ($event: any) => (_ctx.showUserInfo(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.detail")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _withDirectives(_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: ($event: any) => (_ctx.showUserFriends(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.friend")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_permission, ['二级管理']]
            ]),
            _withDirectives(_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: ($event: any) => (_ctx.handleRemote(scope.row)),
              onVIf: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isShow()))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.remotr")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_permission, ['总管理', '二级管理']]
            ]),
            (_ctx.permessionList.includes(201))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleEdit(scope.row))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.modify")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, ['二级管理']]
                ])
              : _createCommentVNode("", true),
            (_ctx.permessionList.includes(205))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "small",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.tofuncEdit(scope.row))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("route.function")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, ['二级管理']]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: ($event: any) => (_ctx.toCardEdit(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("route.cardId")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_permission, ['二级管理']]
            ]),
            (_ctx.deletePermession)
              ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 2,
                  "confirm-button-text": _ctx.t('table.comfirm'),
                  "cancel-button-text": _ctx.t('table.cancel'),
                  "icon-color": "red",
                  title: _ctx.t('input.Are you sure to delete'),
                  onConfirm: ($event: any) => (_ctx.toRowDelete(scope.row))
                }, {
                  reference: _withId(() => [
                    _withDirectives(_createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.delete")), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_directive_permission, ['二级管理']]
                    ])
                  ]),
                  _: 2
                }, 1032, ["confirm-button-text", "cancel-button-text", "title", "onConfirm"]))
              : _createCommentVNode("", true),
            (scope.row.lockedImei)
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 3,
                  size: "small",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.toBindImei(scope.row))
                }, {
                  default: _withId(() => [
                    _hoisted_27
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, ['总管理', '二级管理']]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data", "row-class-name", "header-row-class-name", "onSelectionChange"]), [
      [_directive_loading, _ctx.listLoading]
    ]),
    _withDirectives(_createVNode(_component_el_pagination, {
      total: _ctx.total,
      currentPage: _ctx.listQuery.page.pageNo,
      "onUpdate:currentPage": _cache[25] || (_cache[25] = ($event: any) => (_ctx.listQuery.page.pageNo = $event)),
      limit: _ctx.listQuery.page.pageSize,
      "onUpdate:limit": _cache[26] || (_cache[26] = ($event: any) => (_ctx.listQuery.page.pageSize = $event)),
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      "page-sizes": [10, 20, 50, 100],
      layout: "total, sizes, prev, pager, next, jumper"
    }, null, 8, ["total", "currentPage", "limit", "onSizeChange", "onCurrentChange"]), [
      [_vShow, _ctx.total > 0]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogTableVisible,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.dialogTableVisible = $event)),
      title: _ctx.t('route.batch add groups'),
      width: "50%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_28, [
          _createVNode(_component_el_button, {
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.closeGroupSelectdialog()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.submitGroupSelectToggle()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", null, [
          _createVNode("span", null, _toDisplayString(_ctx.t("form.groupName")) + ": ", 1),
          _createVNode(_component_el_input, {
            placeholder: _ctx.t('input.Specify the default group that users change'),
            style: {"width":"220px"},
            modelValue: _ctx.listGroupSelectQuery.gname,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.listGroupSelectQuery.gname = $event))
          }, null, 8, ["placeholder", "modelValue"]),
          _createVNode(_component_el_button, {
            icon: "el-icon-search",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toGroupSelectSearch()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            icon: "el-icon-refresh-left",
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.toGroupSelectReset()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createVNode(_component_el_table, {
          data: _ctx.GroupList,
          key: _ctx.tableKey,
          "highlight-current-row": "",
          style: {"width":"100%"},
          ref: "singleTableRef",
          onSelectionChange: _ctx.handleCurrentSelectChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              align: "center"
            }),
            _createVNode(_component_el_table_column, { label: "gid" }, {
              default: _withId(({row}) => [
                _createTextVNode(_toDisplayString(row.gid), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('form.groupName')
            }, {
              default: _withId(({row}) => [
                _createTextVNode(_toDisplayString(row.name), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]), [
          [_directive_loading, _ctx.listLoading]
        ]),
        _withDirectives(_createVNode(_component_el_pagination, {
          total: _ctx.totalSelectGroup,
          currentPage: _ctx.listGroupSelectQuery.pageNo,
          "onUpdate:currentPage": _cache[30] || (_cache[30] = ($event: any) => (_ctx.listGroupSelectQuery.pageNo = $event)),
          limit: _ctx.listGroupSelectQuery.pageSize,
          "onUpdate:limit": _cache[31] || (_cache[31] = ($event: any) => (_ctx.listGroupSelectQuery.pageSize = $event)),
          onSizeChange: _ctx.handlegroupSizeSelectChange,
          onCurrentChange: _ctx.handlegroupCurrentSelectChange,
          layout: "total, sizes, prev, pager, next, jumper"
        }, null, 8, ["total", "currentPage", "limit", "onSizeChange", "onCurrentChange"]), [
          [_vShow, _ctx.totalSelectGroup > 0]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogUpload,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.showDialogUpload = $event)),
      title: _ctx.t('table.upload'),
      width: "40%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_36, [
          _createVNode(_component_el_button, { onClick: _ctx.closeImportUser }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.submitUpload()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          model: _ctx.uploadform,
          rules: _ctx.importUserRules,
          ref: "importFormRef"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.AccountType')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.uploadform.type,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.uploadform.type = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, {
                      label: 3,
                      size: "large"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.OneYear")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 0,
                      size: "large"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.ThreeYears")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.GPS reporting cycle')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.uploadform.gpsInterval,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.uploadform.gpsInterval = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withId(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 60 }, {
                      default: _withId(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 300 }, {
                      default: _withId(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 600 }, {
                      default: _withId(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.functiongroup'),
              prop: "fgid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.uploadform.fgid,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.uploadform.fgid = $event)),
                  max: 1
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcGroupList.funcList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.defaultgroup'),
              prop: "defaultGid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "m-2",
                  placeholder: _ctx.t('input.Please select default group'),
                  multiple: "",
                  modelValue: _ctx.uploadform.defaultGid,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.uploadform.defaultGid = $event)),
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  "remote-method": _ctx.remoteMethod,
                  "remote-show-suffix": ""
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.key,
                        label: item.name,
                        value: item.key
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue", "remote-method"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('route.importfile'),
              prop: "file"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_upload, {
                  action: "",
                  modelValue: _ctx.uploadform.file,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.uploadform.file = $event)),
                  "http-request": _ctx.httpRequest,
                  limit: 1,
                  ref: "clearUserList"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, { icon: "el-icon-upload" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.selecctfile")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "http-request"]),
                _createVNode("span", _hoisted_33, [
                  _createVNode("a", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_ctx.t("form.download")) + " ", 1),
                    _hoisted_35
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogUploadIccid,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.showDialogUploadIccid = $event)),
      title: _ctx.t('table.uploadICCID'),
      width: "40%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_44, [
          _createVNode(_component_el_button, { onClick: _ctx.closeImportICCID }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.submitUploadIccid()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          model: _ctx.uploadIccidform,
          rules: _ctx.importICCID,
          ref: "importICCIDRef"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.AccountType')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.uploadIccidform.type,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.uploadIccidform.type = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, {
                      label: 3,
                      size: "large"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.OneYear")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 0,
                      size: "large"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.ThreeYears")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.GPS reporting cycle')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.uploadIccidform.gpsInterval,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.uploadIccidform.gpsInterval = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withId(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 60 }, {
                      default: _withId(() => [
                        _hoisted_38
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 300 }, {
                      default: _withId(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 600 }, {
                      default: _withId(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.functiongroup'),
              prop: "fgid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.uploadIccidform.fgid,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.uploadIccidform.fgid = $event)),
                  max: 1
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcGroupList.funcList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.defaultgroup'),
              prop: "defaultGid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "m-2",
                  placeholder: _ctx.t('input.Please select default group'),
                  multiple: "",
                  modelValue: _ctx.uploadIccidform.defaultGid,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.uploadIccidform.defaultGid = $event)),
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  "remote-method": _ctx.remoteMethodICCID,
                  "remote-show-suffix": ""
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.key,
                        label: item.name,
                        value: item.key
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue", "remote-method"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.agentpw'),
              prop: "agentpwd"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  maxlength: "12",
                  modelValue: _ctx.uploadIccidform.agentpwd,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.uploadIccidform.agentpwd = $event)),
                  placeholder: _ctx.t('input.Please enter the angent password')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('route.importfile'),
              prop: "file"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_upload, {
                  action: "",
                  modelValue: _ctx.uploadIccidform.file,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.uploadIccidform.file = $event)),
                  "http-request": _ctx.httpRequest,
                  limit: 1,
                  ref: "clearIccidList"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, { icon: "el-icon-upload" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.selecctfile")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "http-request"]),
                _createVNode("span", _hoisted_41, [
                  _createVNode("a", _hoisted_42, [
                    _createTextVNode(_toDisplayString(_ctx.t("form.download")) + " ", 1),
                    _hoisted_43
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogFormRenewal,
      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.showDialogFormRenewal = $event)),
      title: _ctx.t('table.BatchRenewal')
    }, {
      footer: _withId(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.showDialogFormRenewal = false))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: _ctx.submitRenewal }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.renewform,
          ref: "renewformRef",
          rules: _ctx.rulesFunc
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.getloginName + ':'
            }, {
              default: _withId(() => [
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.One year of renewal currency remaining")) + _toDisplayString(_ctx.renewform.virtuaOneRenew) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_45,
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Three years of renewal currency remaining")+":") + _toDisplayString(_ctx.renewform.virtuaRenew) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_46,
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Remaining promotional account renewal currency")) + _toDisplayString(_ctx.renewform.renew) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_47,
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.availableIndustrycurrency")) + _toDisplayString(_ctx.renewform.tradeCount) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.renewaccount')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_collapse, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_collapse_item, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renewform.nameList, (item) => {
                          return (_openBlock(), _createBlock("div", {
                            key: item.uid,
                            label: item.uid
                          }, _toDisplayString(item.uid) + " - " + _toDisplayString(item.account) + " - " + _toDisplayString(item.name), 9, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.functiongroup'),
              prop: "fids"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.renewform.fids,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.renewform.fids = $event)),
                  max: 1,
                  onChange: _ctx.changeFunc
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcFidsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.isRenewType)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "续费模式:"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.isRenew,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.isRenew = $event)),
                      size: "small",
                      "active-text": "一年一续",
                      "inactive-text": "三年一续",
                      onChange: _ctx.clickRenewType
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('statistics.totalnumofconsumable')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_tag, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Oneyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.renewform.useVirtuaOneRenew) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_48,
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: 
              _ctx.t(
                'input.Preferential accounts that have not reached three years will be deducted preferential coins, and three-year renewal coins will be deducted after three years'
              )
            ,
                  placement: "top-start"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_tag, null, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("statistics.Threeyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.renewform.useVirtuaRenew) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["content"]),
                _hoisted_49,
                _createVNode(_component_el_tag, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.PromotionalAccountRenewalCoin")) + ":" + _toDisplayString(_ctx.renewform.useRenew) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_50,
                _createVNode(_component_el_tag, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Industrycurrency")) + ":" + _toDisplayString(_ctx.renewform.useTradeCount) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogFormVip,
      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.showDialogFormVip = $event)),
      title: _ctx.t('route.VIP batch renewal')
    }, {
      footer: _withId(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.showDialogFormVip = false))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: _ctx.submitVip }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.vipform,
          ref: "vipformRef",
          rules: _ctx.rulesFunc
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.getloginName + ':'
            }, {
              default: _withId(() => [
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Remaining VIP renewal currency")) + _toDisplayString(_ctx.vipform.virtua) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_51,
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.availableIndustrycurrency")) + _toDisplayString(_ctx.vipform.tradeCount) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.renewaccount')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_collapse, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_collapse_item, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.vipform.nameList, (item) => {
                          return (_openBlock(), _createBlock("div", {
                            key: item.uid,
                            label: item.uid
                          }, _toDisplayString(item.uid) + " - " + _toDisplayString(item.account) + " - " + _toDisplayString(item.name), 9, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.functiongroup'),
              prop: "fids"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.vipform.fids,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.vipform.fids = $event)),
                  max: 1,
                  onChange: _ctx.changeFuncVip
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcFidsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('statistics.totalnumofconsumable')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_tag, { size: "small" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Remaining VIP renewal currency")) + ":" + _toDisplayString(_ctx.vipform.useVirtuaOneRenew) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_52,
                _createVNode(_component_el_tag, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Industrycurrency")) + ":" + _toDisplayString(_ctx.vipform.useVipTradeCount) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormtoggle,
      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.dialogFormtoggle = $event)),
      title: _ctx.t('route.function'),
      width: "30%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_53, [
          _createVNode(_component_el_button, {
            onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.closedialog()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.submitDisToggle()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formdistribute",
          "label-width": "100px",
          model: _ctx.funcForm,
          rules: _ctx.ruluesFuncset
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { label: _ctx.getloginName }, {
              default: _withId(() => [
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.availableIndustrycurrency")) + _toDisplayString(_ctx.tradeSurlpusCount) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.Account')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.funcForm.account,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.funcForm.account = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.name')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.funcForm.name,
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.funcForm.name = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('route.function')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.funcForm.funcValueList,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.funcForm.funcValueList = $event)),
                  max: 1
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funceditList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        label: item.id,
                        key: item.id
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormGroup,
      "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (_ctx.dialogFormGroup = $event)),
      title: _ctx.t('table.editgroup'),
      width: "50%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_55, [
          _createVNode(_component_el_button, {
            onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.closeGroupdialog()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.submitGroupToggle()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", null, [
          _createVNode("span", null, _toDisplayString(_ctx.t("form.groupName")) + ":", 1),
          _createVNode(_component_el_input, {
            placeholder: _ctx.t('input.Specify the default group that users change'),
            style: {"width":"220px"},
            modelValue: _ctx.listGroupQuery.pttGroupEntity.idOrName,
            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.listGroupQuery.pttGroupEntity.idOrName = $event))
          }, null, 8, ["placeholder", "modelValue"]),
          _createVNode(_component_el_button, {
            icon: "el-icon-search",
            onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.toGroupSearch()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            icon: "el-icon-refresh-left",
            onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.toGroupReset()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_table, {
            key: _ctx.tableKey,
            data: _ctx.groupList,
            "highlight-current-row": "",
            style: {"width":"100%"},
            ref: "singleTableRef",
            onCurrentChange: _ctx.handleCurrentRiadioChange
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                label: _ctx.t('table.select'),
                width: "80"
              }, {
                default: _withId(({row}) => [
                  _createVNode(_component_el_radio, {
                    label: row.gid,
                    modelValue: _ctx.radioTable,
                    "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_ctx.radioTable = $event))
                  }, {
                    default: _withId(() => [
                      _hoisted_54
                    ]),
                    _: 2
                  }, 1032, ["label", "modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, { label: "id" }, {
                default: _withId(({row}) => [
                  _createTextVNode(_toDisplayString(row.gid), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: _ctx.t('form.groupName')
              }, {
                default: _withId(({row}) => [
                  _createTextVNode(_toDisplayString(row.name), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data", "onCurrentChange"]), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            total: _ctx.totalGroup,
            "current-page": _ctx.listQuery.page.pageNo,
            "onUpdate:current-page": _cache[67] || (_cache[67] = ($event: any) => (_ctx.listQuery.page.pageNo = $event)),
            limit: _ctx.listGroupQuery.page.pageSize,
            "onUpdate:limit": _cache[68] || (_cache[68] = ($event: any) => (_ctx.listGroupQuery.page.pageSize = $event)),
            onSizeChange: _ctx.handlegroupSizeChange,
            onCurrentChange: _ctx.handlegroupCurrentChange,
            layout: "total, sizes, prev, pager, next, jumper"
          }, null, 8, ["total", "current-page", "limit", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.totalGroup > 0]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormCard,
      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.dialogFormCard = $event)),
      title: _ctx.t('route.cardId'),
      width: "30%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_56, [
          _createVNode(_component_el_button, {
            onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.closeCarddialog()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.submitCardToggle()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formcardbute",
          "label-width": "140px",
          model: _ctx.cardForm,
          rules: _ctx.cardRules
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.mastarICCID'),
              prop: "masterIccid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.cardForm.masterIccid,
                  "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_ctx.cardForm.masterIccid = $event)),
                  maxlength: "20"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.secondICCID'),
              prop: "slaveIccid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.cardForm.slaveIccid,
                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (_ctx.cardForm.slaveIccid = $event)),
                  maxlength: "20"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.agentpw')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.cardForm.agentpwd,
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (_ctx.cardForm.agentpwd = $event)),
                  type: "password",
                  maxlength: "12",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.ICCIDLOGIN')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.checkType_card,
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.checkType_card = $event)),
                  label: _ctx.t('form.YES'),
                  size: "large",
                  onChange: _ctx.handleCardCheck
                }, null, 8, ["modelValue", "label", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogBindImei,
      "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (_ctx.showDialogBindImei = $event)),
      title: "设备换绑",
      width: "640px",
      onClosed: _cache[88] || (_cache[88] = ($event: any) => (_ctx.closeBindImeiDialog()))
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_78, [
          _createVNode(_component_el_button, {
            onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.closeBindImeiDialog()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.submitBindImei()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        (_ctx.bindImeiRow)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              ref: "bindImeiFormRef",
              class: "bind-imei-dialog",
              model: _ctx.bindImeiForm,
              rules: _ctx.bindImeiFormRules,
              "label-width": "160px",
              "label-position": "right",
              onSubmit: _cache[84] || (_cache[84] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  class: "bind-imei-form-item--readonly",
                  label: _ctx.t('table.imeiBindDialogUserRemainLabel')
                }, {
                  default: _withId(() => [
                    _createVNode("span", _hoisted_57, _toDisplayString(_ctx.bindImeiRemainCount === null || _ctx.bindImeiRemainCount === undefined
              ? "—"
              : _ctx.bindImeiRemainCount), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  class: "bind-imei-form-item--readonly",
                  label: "原IMEI"
                }, {
                  default: _withId(() => [
                    _createVNode("span", _hoisted_58, _toDisplayString(_ctx.bindImeiRow.lockedImei), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "bind-imei-form-item--input",
                  label: "换绑IMEI",
                  prop: "newImei"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.bindImeiForm.newImei,
                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.bindImeiForm.newImei = $event)),
                      clearable: "",
                      maxlength: "15",
                      "show-word-limit": "",
                      placeholder: 
              _ctx.bindImeiUserRequestedSec
                ? '选填；仅绑定副IMEI时可不填'
                : '请输入15位数字IMEI'
            
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                (_ctx.bindImeiHasSecLocked)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      class: "bind-imei-form-item--readonly",
                      label: "副IMEI"
                    }, {
                      default: _withId(() => [
                        _createVNode("span", _hoisted_59, _toDisplayString(_ctx.bindImeiRow.secLockedImei), 1)
                      ]),
                      _: 1
                    }))
                  : (_ctx.bindImeiUserRequestedSec)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_form_item, {
                          class: "bind-imei-sec-divider-row",
                          "label-width": 0
                        }, {
                          default: _withId(() => [
                            _hoisted_60
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "bind-imei-form-item--input",
                          label: "绑定副IMEI",
                          prop: "secImei"
                        }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_61, [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.bindImeiForm.secImei,
                                "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (_ctx.bindImeiForm.secImei = $event)),
                                clearable: "",
                                maxlength: "15",
                                "show-word-limit": "",
                                placeholder: "请输入15位数字副IMEI"
                              }, null, 8, ["modelValue"]),
                              _createVNode("button", {
                                type: "button",
                                class: "bind-imei-sec-close",
                                title: "取消添加副IMEI",
                                "aria-label": "取消添加副IMEI",
                                onClick: _cache[81] || (_cache[81] = 
//@ts-ignore
(...args) => (_ctx.cancelBindImeiSecAdd && _ctx.cancelBindImeiSecAdd(...args)))
                              }, [
                                _hoisted_62
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 2,
                        class: "bind-imei-add-sec-row bind-imei-form-item--input",
                        label: " "
                      }, {
                        default: _withId(() => [
                          _createVNode("span", {
                            class: "bind-imei-add-sec-link",
                            role: "button",
                            tabindex: 0,
                            onClick: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.requestBindImeiSecAdd && _ctx.requestBindImeiSecAdd(...args))),
                            onKeydown: _cache[83] || (_cache[83] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.requestBindImeiSecAdd && _ctx.requestBindImeiSecAdd(...args)), ["prevent"]), ["enter"]))
                          }, [
                            _hoisted_63,
                            _hoisted_64
                          ], 32)
                        ]),
                        _: 1
                      }))
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_65, [
          _createVNode("div", _hoisted_66, [
            _createVNode("p", null, [
              _createVNode("span", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintAdminMaxRebindPrefix", {
                adminName: _ctx.bindImeiHintAdminName
              })), 1),
              _createVNode("strong", _hoisted_67, _toDisplayString(_ctx.bindImeiAdminRemainCount === null ||
              _ctx.bindImeiAdminRemainCount === undefined
                ? "—"
                : _ctx.bindImeiAdminRemainCount), 1),
              _createVNode("span", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintAdminMaxRebindSuffix")), 1)
            ]),
            _createVNode("p", _hoisted_68, [
              _createVNode("span", _hoisted_69, _toDisplayString(_ctx.t("table.imeiBindDialogUserCompleteLabel", {
                adminName: _ctx.bindImeiHintAdminName
              })), 1),
              (
                _ctx.bindImeiUserCompleteCount !== null &&
                _ctx.bindImeiUserCompleteCount !== undefined
              )
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("strong", _hoisted_70, _toDisplayString(_ctx.bindImeiUserCompleteCount), 1),
                    _createVNode("span", null, _toDisplayString(_ctx.t("table.imeiBindDialogUserCompleteCountSuffix")), 1)
                  ], 64))
                : (_openBlock(), _createBlock("strong", _hoisted_71, "—"))
            ]),
            _createVNode("p", _hoisted_72, [
              _createVNode("span", _hoisted_73, _toDisplayString(_ctx.t("table.imeiBindDialogAdminTotalCompleteLabel", {
                adminName: _ctx.bindImeiHintAdminName
              })), 1),
              (
                _ctx.bindImeiAdminCompleteCount !== null &&
                _ctx.bindImeiAdminCompleteCount !== undefined
              )
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("strong", _hoisted_74, _toDisplayString(_ctx.bindImeiAdminCompleteCount), 1),
                    _createVNode("span", null, _toDisplayString(_ctx.t("table.imeiBindDialogAdminTotalCountSuffix")), 1)
                  ], 64))
                : (_openBlock(), _createBlock("strong", _hoisted_75, "—"))
            ]),
            _createVNode("p", null, [
              _createVNode("span", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintBaseTotalLinePrefix", {
                adminName: _ctx.bindImeiHintAdminName
              })), 1),
              _createVNode("strong", _hoisted_76, _toDisplayString(_ctx.bindImeiUserCount === null || _ctx.bindImeiUserCount === undefined
                ? "—"
                : _ctx.bindImeiUserCount), 1),
              _createVNode("span", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintBaseTotalLineSuffix")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_77, [
            _createVNode("p", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintLine2")), 1),
            _createVNode("p", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintLine3")), 1),
            _createVNode("p", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintSecLine1")), 1),
            _createVNode("p", null, _toDisplayString(_ctx.t("table.imeiBindDialogHintSecLine2")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogUserInfo,
      "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (_ctx.showDialogUserInfo = $event)),
      title: _ctx.t('table.detail')
    }, {
      footer: _withId(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.showDialogUserInfo = false))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          "label-width": "140px",
          rules: _ctx.rules,
          model: _ctx.ruleForm
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.Account")) + ": " + _toDisplayString(_ctx.ruleForm.account), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(" uid: " + _toDisplayString(_ctx.ruleForm.uid), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.designation")) + ": " + _toDisplayString(_ctx.ruleForm.name), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.canViewPassword)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 12
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("table.password")) + ": " + _toDisplayString(_ctx.ruleForm.password), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.defaultgroup")) + ": " + _toDisplayString(_ctx.ruleForm.defaultGroupName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.GPS reporting cycle")) + ": " + _toDisplayString(_ctx.ruleForm.gpsInterval) + "s ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.createTime")) + ": " + _toDisplayString(_ctx.ruleForm.createDate), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("search.onlinestatus")) + ": " + _toDisplayString(_ctx.ruleForm.onLine == 0
                  ? _ctx.t("dashboard.online")
                  : _ctx.t("dashboard.offline")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.expireTime")) + ": " + _toDisplayString(_ctx.ruleForm.validDate), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.status")) + ": " + _toDisplayString(_ctx.ruleForm.usrValid == 2
                  ? _ctx.t("table.activation")
                  : _ctx.t("table.suspend")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(" IMEI: " + _toDisplayString(_ctx.ruleForm.imei), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("form.functiongroup")) + ": ", 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.joinFuncGroupsList.joinFuncList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_button, {
                            size: "small",
                            key: item.id
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.defaultgroupID")) + ":" + _toDisplayString(_ctx.ruleForm.defaultGid), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("table.Remark")) + ": " + _toDisplayString(_ctx.ruleForm.remarks), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogFriendsInfo,
      "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => (_ctx.showDialogFriendsInfo = $event)),
      title: _ctx.t('table.friend'),
      width: "65%"
    }, {
      footer: _withId(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.showDialogFriendsInfo = false))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.back")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleFriends
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          modelValue: _ctx.friendsform,
          "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (_ctx.friendsform = $event)),
          style: {"max-width":"80%"},
          "label-position": "right",
          class: "friend-label"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.Account')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.friendsform.account,
                  "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.friendsform.account = $event)),
                  disabled: "",
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.designation')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.friendsform.name,
                  "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => (_ctx.friendsform.name = $event)),
                  disabled: "",
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_transfer, {
                  modelValue: _ctx.friendsform.friends,
                  "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => (_ctx.friendsform.friends = $event)),
                  filterable: "",
                  data: _ctx.friendsDataList.data,
                  titles: [_ctx.t('table.Items'), _ctx.t('table.Selected')]
                }, {
                  default: _withId(({option}) => [
                    _createVNode("span", _hoisted_79, _toDisplayString(option.key), 1),
                    _createVNode("span", _hoisted_80, _toDisplayString(option.name), 1)
                  ]),
                  "left-footer": _withId(() => [
                    _createVNode("span", _hoisted_81, _toDisplayString(_ctx.t("table.ID")), 1),
                    _createVNode("span", null, _toDisplayString(_ctx.t("table.designation")), 1)
                  ]),
                  "right-footer": _withId(() => [
                    _createVNode("span", _hoisted_82, _toDisplayString(_ctx.t("table.ID")), 1),
                    _createVNode("span", null, _toDisplayString(_ctx.t("table.designation")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "data", "titles"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogGPS,
      "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => (_ctx.showDialogGPS = $event)),
      title: _ctx.t('route.Barch GPS'),
      width: "30%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_87, [
          _createVNode(_component_el_button, {
            onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.closeSetGps()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.submitSetGps()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          model: _ctx.uploadSetGpsform,
          ref: "setGPSRef"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.GPS reporting cycle')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.uploadSetGpsform.gpsInterval,
                  "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => (_ctx.uploadSetGpsform.gpsInterval = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withId(() => [
                        _hoisted_83
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 60 }, {
                      default: _withId(() => [
                        _hoisted_84
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 300 }, {
                      default: _withId(() => [
                        _hoisted_85
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 600 }, {
                      default: _withId(() => [
                        _hoisted_86
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialogFunc,
      "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => (_ctx.showDialogFunc = $event)),
      title: _ctx.t('route.Batch FuncGroup'),
      width: "30%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_88, [
          _createVNode(_component_el_button, {
            onClick: _cache[102] || (_cache[102] = ($event: any) => (_ctx.closeAddFunc()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[103] || (_cache[103] = ($event: any) => (_ctx.submitAddFunc()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formdistribute",
          "label-width": "100px",
          model: _ctx.funcForm,
          rules: _ctx.ruluesFuncset
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { label: _ctx.getloginName }, {
              default: _withId(() => [
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.availableIndustrycurrency")) + _toDisplayString(_ctx.tradeSurlpusCount) + _toDisplayString(_ctx.t("statistics.piece")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('route.function')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.funcForm.funcValueList,
                  "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => (_ctx.funcForm.funcValueList = $event)),
                  max: 1
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funceditList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        label: item.id,
                        key: item.id
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
})